export default "__VITE_ASSET__d7218d1a__"